import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, Switch, TextField } from '@mui/material';
import dayjs from 'dayjs';
import * as React from 'react';
import { useContext } from 'react';
import { UserContext } from '../../contexts/userContext';
import { AddPagosPayloadType } from '../../hooks/addPAgo';
import { ReporteDeudaType } from '../../hooks/getDeuda';
import { IndicatorButton } from '../IndicatorButton';
import { emptyPagoFamiliar } from './DeudaReportFamiliar';

export interface NewPago extends AddPagosPayloadType {
  open: boolean;
  montoEfectivo: number;
  montoTransferencia: number;
  cuotas?: ReporteDeudaType[];
}

export interface PagoDialogProps {
  isLoading: boolean,
  refetch: ()=>void,
  nuevoPago: NewPago,
  setNuevoPago: React.Dispatch<React.SetStateAction<NewPago>>
  montoEfectivo?: number,
  montoTransferencia?: number,
}

export function PagoDialog(props: PagoDialogProps) {
  const { isLoading, refetch, nuevoPago, setNuevoPago, montoEfectivo, montoTransferencia } = props;

  const { user } = useContext(UserContext);
  if (!user?._id) return null;

  return (
    <Dialog open={nuevoPago.open} >
      <DialogTitle>Detalles del pago</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              margin="dense"
              id="monto"
              label="Monto"
              type="number"
              fullWidth
              variant="standard"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const newValue = event.target.value;
                if (!newValue || (newValue.match(/^\d*\.?\d*$/) && Number(newValue) >= 0)) {
                  setNuevoPago((prev) => ({ ...prev, monto: Number(newValue) }));
                }
              }}
              error={!nuevoPago.monto || nuevoPago.monto <= 0}
              helperText={!nuevoPago.monto || nuevoPago.monto <= 0 ? 'El monto no puede quedar vacio' : ''}
              value={nuevoPago.monto || ''}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              margin="dense"
              id="fechapago"
              label="Fecha"
              type="date"
              fullWidth
              variant="standard"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setNuevoPago((prev) => ({ ...prev, fecha:event.target.value }));
              }}
              value={nuevoPago.fecha}
            />
          </Grid>
          <Grid
            xs={6}
            item
            style={{
              justifyContent:'center',
              alignItems:'flex-end',
            }}
          >
            <FormControlLabel
              control={<Switch
                color="primary"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  const esTransferencia = event.target.checked;
                  const nuevoMonto = esTransferencia
                    ? (montoTransferencia ?? nuevoPago.monto)
                    : (montoEfectivo ?? nuevoPago.monto);
                  setNuevoPago((prev) => ({
                    ...prev,
                    transferencia: esTransferencia,
                    monto: nuevoMonto,
                  }));
                }}
              />}
              checked={nuevoPago.transferencia}
              label="Pago por transferencia"
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              margin="dense"
              id="obs"
              label="Observaciones"
              type="text"
              fullWidth
              variant="standard"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setNuevoPago((prev) => ({ ...prev, obs: event.target.value }));
              }}
              value={nuevoPago.obs}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <IndicatorButton
          label='Guardar Pago'
          loading={isLoading}
          onClick={() => {refetch();}}
        />
        <Button
          variant="contained"
          disabled={isLoading}
          onClick={() => {setNuevoPago(emptyPagoFamiliar);}}
        >
       Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
}